<script>

	import { Router, Link, Route } from "svelte-navigator";

	import Intro from './intro/Intro.svelte';
	import Breakpoint from './components/Breakpoint.svelte';
	import Mobile from './navigation/Mobile.svelte';
	import Desktop from './navigation/Desktop.svelte';
	import Posts from './content/Posts.svelte';
	import Post from './content/Post.svelte';
  	import { onMount } from "svelte";

	export let site;
	export let posts;
	export let intro;
	export let single;

	function updateCssVariables(){
		document.documentElement.style.setProperty('--100vh', window.innerHeight + 'px');
	}
	onMount(()=>{
		updateCssVariables();
		setTimeout(updateCssVariables, 100);
		setTimeout(updateCssVariables, 200);
		setTimeout(updateCssVariables, 300);
	});

</script>

<svelte:window on:resize={updateCssVariables} />

<Intro {intro} />

<Router>

	<div class="wrapper">

		<Breakpoint breakpoint={720}>
			<svelte:fragment slot="mobile">
				<Mobile {site} />
			</svelte:fragment>
			<svelte:fragment slot="desktop">
				<Desktop {site} />
			</svelte:fragment>
		</Breakpoint>

		
		<div id="content" class="content">
			<Route path="/">
				<Posts {posts} />
			</Route>
			<Route path="*">
				<Post post={single} />
			</Route>
		</div>

	</div>

</Router>

<style>

	.content {
		padding: 1rem;
		padding-right: 0;
	}
	.wrapper {
		min-height: var(--100vh);
	}
	@media (min-width: 720px){
		.wrapper {
			display: flex;
			width: 100vw;
			max-width: 100vw;
		}
		.content {
			flex: 1 1 80%;
		}
	}

</style>